import styled from 'styled-components'

export const H5 = styled.h5`
  font-weight: 500;
  font-size: 0.875em;
  line-height: 1.125em;
  color: ${({ theme }) => theme.darkGrey};
`
